import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import History from './pages/History';
import GalleryWeekend from './pages/GalleryWeekend';
import MapLocation from './pages/Map';
import MapStyleTest from './pages/MapStyleTest';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import Mehr from './pages/Mehr';

// Tracks SPA route changes as page_view events in GTM/GA4
function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'page_view',
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
  }, [location]);
  return null;
}

function App() {
  return (
    <Router>
      <RouteTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/map/:type" element={<MapLocation />} />
        <Route path="/map" element={<MapLocation />} />
        <Route path="/map-test" element={<MapStyleTest />} />
        <Route path="/historie" element={<History />} />
        <Route path="/gallery-weekend" element={<GalleryWeekend />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/mehr" element={<Mehr />} />
      </Routes>
    </Router>
  );
}

export default App;
